import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { SizeOption } from '../sizeoption';
import { OrientationOption } from '../orientationoption';
import { SettingsItem } from '../settingsitem';
import { LocaleContext } from '../LocaleContext';
import { MarginsOption } from './MarginsOption';
export class PageOption extends React.PureComponent {
    render() {
        return (_jsx(LocaleContext.Consumer, { children: (context) => (_jsx(SettingsItem, { label: context.locale.pageOption, children: _jsxs("div", { className: 'sg-u-vs-1', children: [_jsx(SizeOption, { locale: context.locale.size }), _jsx(OrientationOption, { locale: context.locale.orientation }), _jsx(MarginsOption, { label: context.locale.margins })] }) })) }));
    }
}
//# sourceMappingURL=component.js.map